export const DEFAULT_ICON_PROPS = {
    width: '1200pt',
    height: '1200pt',
    version: '1.1',
    viewBox: '0 0 1200 1200',
}
